import { IconMailCheck as TablerIcon } from '@tabler/icons-react';
import { cn } from '@ui-kit/utils';
import type { IconProps } from '@/components/icons/types';

const MailCheckIcon = ({ className, ...props }: IconProps) => (
  <TablerIcon className={cn('size-6 shrink-0', className)} {...props} />
);

export default MailCheckIcon;
